import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {View, Heading, Text} from "@unibuddy/patron";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_BLOGS_COMING_SOON, INTL_NO_BLOGS_MESSAGE} from "../../../../translations/blogs";

export const NoDataMessage = () => {
    const {t} = useTranslation(IntlNamespaces.BLOGS);

    return (
        <View padding="small-medium" gap="small-medium">
            <Heading level={2} size="xxsmall" align="center">
                {t(INTL_BLOGS_COMING_SOON.key, INTL_BLOGS_COMING_SOON.defaultValue)}
            </Heading>
            <Text align="center">
                {t(INTL_NO_BLOGS_MESSAGE.key, INTL_NO_BLOGS_MESSAGE.defaultValue)}
            </Text>
        </View>
    );
};
